export const checkConnection = () => {
  return new Promise((resolve, reject) => {
    if (navigator.onLine) {
      resolve(true);
    } else {
      reject(new Error('OFFLINE'));
    }
  });
};
